import * as analytics from './analytics'
//import { getParameterByName } from './queryStringHelper';

function parseFPTIValue(key) {
	let fptiData;
	try {
		fptiData = JSON.parse(document.getElementById('fptiData') && document.getElementById('fptiData').innerHTML || {});
	} catch (e) {
		fptiData = {};
	}
	let nameValues = [];
	let pairs = decodeURIComponent(fptiData).split('&');
	let i;
	for (i = 0; i < pairs.length; i++) {
		let parts = pairs[i].split('=');
		nameValues[parts[0]] = parts[1];
	}
	return nameValues[key];
}

function getPgrp() {
	try {
		const windowPath = window.location.pathname;
		let modifiedurl = windowPath.replace(/\//g, ":");
		return `main${modifiedurl}`;
	} catch (error) {
		trackError({
			message: 'FPTI_PGRP_ERROR',
			code: window.location.href,
			error
		});
	}
	// No pages matched. Use value sent by server
	return {
		pgrp: parseFPTIValue('pgrp'),
		page: parseFPTIValue('page')
	}
}

export function trackButtonClick(eventType, data) {
	const pgrp = getPgrp();	
	analytics.trackLink(eventType, pgrp, `${pgrp}`, 'link', data);
}

export function trackButtonClickWithData(eventType, data) {
	const pgrp = getPgrp();
	analytics.trackLinkWithData(eventType, pgrp, `${pgrp}`, data, 'link');
}

export function trackAjaxPageLoad(eventType, pgrp, pname) {
	analytics.trackLink(eventType, pgrp, pname, 'link');
}

export function trackError(err) {
	analytics.trackError(err);
}

export function trackPage(pname) {
	const pgrp = getPgrp();
	analytics.trackPageWithData(pgrp, pname);
}

export function trackPageWithData(pname,data) {
	const pgrp = getPgrp();
	analytics.trackPageWithData(pgrp, pname, data);
}

export function trackEventWithData(eventName, data) {
	analytics.trackEventWithData(eventName, data);
}

export function trackEventWithGlobalData(eventName, data) {
	analytics.trackEventWithGlobalData(eventName, data);
}


